<template>
  <base-list-overview
    controller="User"
    :visible="visible"
  />
</template>

<script>
import BaseListOverview from '@/components/shared/base/base-list-overview'
import ContentMixin from '@/mixins/content-mixin'

export default {
  name: 'UserManagementUsersOverview',
  components: {
    BaseListOverview
  },
  mixins: [
    ContentMixin
  ]
}
</script>
